/*jshint esversion: 6 */
(function($) {
	'use strict';

	/* Front page hero background slider */
	var nextslide = function () {
		var images = jQuery(".flex-content.hero").find(".hero_images.scroll").find(".hero_image");
		if (images.length > 1) {
			var curr = images.filter(".current").length ? images.filter(".current")	: images.first();
			var next = curr.next().length ? curr.next() : images.first();
			curr.addClass("prev").removeClass("current");
			next.addClass("current").removeClass("prev");
			setTimeout(function () {
				curr.removeClass("prev");
			}, 7500);
		}
	};

	jQuery(document).ready(function () {
		/* Front page hero background slider */
		if ( $('body').hasClass('home') ) {
			var style = document.createElement('style');
			style.innerHTML = 'div.hero_images.scroll div.hero_image.current, div.hero_images.scroll div.hero_image.prev { transform: translate3d(100px, 0, 100px) !important; }';
			document.head.appendChild(style);
			var intervalId = window.setInterval(function () {
				nextslide();
			}, 7500);
		}

		setTimeout(function() {
			/* Calendar styling */
			jQuery('span.title.confirmed').each(function() {
			});
			jQuery('span.title.confirmed:contains("Stengt")').each(function() {
				jQuery(this).parent('li').addClass('event-closed');
			});
			jQuery('span.title.confirmed:contains("Åpent for grupper")').each(function() {
				jQuery(this).parent('li').addClass('event-groups-only');
			});
		}, 2000);

	});

	/**
	 * CLICK EVENTS
	 */
	function clickEventHandler() {
		var klatreskogenTabs = $('#klatreskogen-tabs').length;
		if ( klatreskogenTabs ) {
			const urlParams = new URLSearchParams(window.location.search);
			const currTab = urlParams.get('tab');
			if ( currTab ) {
				var targetEle = $('#' + currTab);
				if ( targetEle.length ) {
					$('#klatreskogen-tabs .wp-block-button').removeClass('active');
					$('#klatreskogen-tabs a[rel="' + currTab + '"]').parent().addClass('active');
					$('#klatreskogen-tabs').siblings('div[id]').removeClass('visible');
					targetEle.addClass('visible');
					$('body').scrollTop('#' + currTab);
					$('html, body').animate({
						scrollTop: targetEle.offset().top
					}, 2000);
				}
			}
			$('#klatreskogen-tabs a').on('click ready', function(e) {
				e.stopImmediatePropagation();
				e.preventDefault();
				var clickedTab = $(this).attr('rel');
				$(this).parent().siblings().removeClass('active');
				$(this).parent().addClass('active');
				$('#klatreskogen-tabs').siblings('div[id]').removeClass('visible');
				$('#klatreskogen-tabs').siblings('div[id="' + clickedTab + '"]').addClass('visible');
				urlParams.set('tab', clickedTab);
				var newRelativePathQuery = window.location.pathname + '?' + urlParams.toString();
    			history.pushState(null, '', newRelativePathQuery);
			});
		}

	}

	$(window).bind("load", function() {
		clickEventHandler();
	});

	/* Re-attach click events after AJAX call */
	$(document).ajaxComplete( function() {
		clickEventHandler();
	});

})(jQuery);
